import { toast } from 'react-toastify';

import { STATE_LIST } from '../constants/stateList';

const isEqual = (a, b) => {
    if (a === b) return true;

    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return false;
        return a.every((itemA) => b.some((itemB) => isEqual(itemA, itemB)));
    }

    if (typeof a === 'object' && typeof b === 'object' && a && b) {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;

        return aKeys.every((key) => isEqual(a[key], b[key]));
    }

    return false;
};

export const isFormDirty = (originalValues, newValues) => {
    const objectKeys = Object.keys(originalValues);
    return objectKeys.some((key) => !isEqual(originalValues[key], newValues[key]));
};

export const handleCopyClick = async (textToCopy, copyItemText = 'Text') => {
    if (navigator?.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(textToCopy);
            toast.success(`${copyItemText} copied!`);
            return;
        } catch {}
    }

    // Fallback for unsupported browsers
    const textarea = document.createElement('textarea');
    textarea.value = textToCopy;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);

    textarea.select();
    document.execCommand('copy');

    document.body.removeChild(textarea);
    toast.success(`${copyItemText} copied!`);
};

export const normalizeStateValue = (value) => {
    if (!value) return '';

    const valueNormalized = value.trim().toUpperCase();

    // Case 1: Matches a value like "WI"
    if (STATE_LIST[valueNormalized]) {
        return valueNormalized;
    }

    // Case 2: Matches a label like "Wisconsin"
    const match = Object.values(STATE_LIST).find((state) => state.label.toUpperCase() === valueNormalized);

    return match?.value ?? '';
};
